// extracted by mini-css-extract-plugin
var _1 = "sibdD";
export { _1 as "warning" }
